// Money formatting helpers.
// Products are priced and charged in INR. USD is shown as a friendly
// display-only approximation for international shoppers.
// Rate is intentionally a constant — payment providers only ever charge INR.
export const USD_RATE = 0.012; // 1 INR ≈ 0.012 USD (~₹83 per USD)

const num = (v) => Number(v) || 0;

export const fmtINR = (n) =>
  num(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const fmtUSD = (n) =>
  (num(n) * USD_RATE).toLocaleString("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
